import React, { useCallback } from 'react';
import { communicationUtilities } from '@incentivegames/ig-frontend-common/lib/utilities/communicationUtilities';

import config from 'theme/config';
import './InfoButton.scss';

const InfoButton = () => {
  const onClick = useCallback(() => communicationUtilities.sendPostMessage.howToPlay(), []);

  return (
    <button className="info-button" aria-label="Information" onClick={onClick} data-testid="info-button">
      <svg fill={`${config.settings.themeTextColour ?? '#000'}`} className="info-button__svg" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <path d="M20,39A19,19,0,1,1,39,20,19,19,0,0,1,20,39ZM20,3A17,17,0,1,0,37,20,17,17,0,0,0,20,3Z" />
        <path d="M22.29,26.65l-1.7.77L22.8,16.1a1.6,1.6,0,0,0-2.38-1.7l-4.17,2.3a1.62,1.62,0,0,0,1.62,2.81l1-.51-2.13,10.8a1.7,1.7,0,0,0,1.62,2,1.6,1.6,0,0,0,.68-.17l4.51-2a1.62,1.62,0,1,0-1.28-3Zm0,0" />
        <path d="m21.19 11.34a2.3 2.3 0 1 0-2.3-2.34 2.29 2.29 0 0 0 2.3 2.3z" />
      </svg>
    </button>
  );
};

export default InfoButton;
